export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5540.92c9e026.jpg";